import { BasicWriter } from "@/components/Writer/BasicWriter";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { useExpertEditData } from "@/data/use-expert-edit-data";
import { useExpertData } from "@/data/use-experts-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { useEffect, useRef } from "react";

export function ExpertToneOfVoicePage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { expert } = useExpertEditData({ groupUuid, kitUuid });

  if (!expert) {
    return null;
  }

  return (
    <Page document>
      <PageHeader document>
        <PageHeader.Title>Tone of Voice</PageHeader.Title>
      </PageHeader>
      <ExpertBody key={expert.uuid} exportUuid={expert.uuid} />
    </Page>
  );
}

function ExpertBody({ exportUuid }: { exportUuid: string }) {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const contextRef = useRef<string>("");
  const tovRef = useRef<string>("");
  const hasInitialized = useRef(false);
  const { updateExpert, expert } = useExpertData(
    groupUuid,
    kitUuid,
    exportUuid,
  );

  useEffect(() => {
    if (expert && !hasInitialized.current) {
      contextRef.current = expert.context;
      tovRef.current = expert.toneOfVoice;
      hasInitialized.current = true;
    }
  }, [expert]);

  // Handle tone of voice updates from BasicWriter (debounced internally)
  const handleToneOfVoiceUpdate = (html: string) => {
    if (expert) {
      updateExpert({
        toneOfVoice: html,
      });
    }
  };

  if (!expert) {
    return null;
  }

  return (
    <PageBody document>
      <BasicWriter
        hasToolbar={false}
        key={`tone-of-voice-${expert.uuid}`}
        content={expert.toneOfVoice}
        onUpdate={handleToneOfVoiceUpdate}
        onChange={(html) => {
          tovRef.current = html;
        }}
        placeholder="Define the expert's tone of voice..."
      />
    </PageBody>
  );
}
